<template>
  <div class="sp-color-bg-4 text-left">
    <div class="CargoOrderEdit2">
      <div class="card flex-60">
        <div class="sp-color-bg-4">
          <span class="font18 fs-int">{{ $l('FullBriefTerms') }}</span>
          <SpSelect v-model="cargoOrders.term.fullTermId" class="position-input" name="cargoOrders.term.fullTermId" width="790"
                    type="warn" :options="fullTerms" @search="searchFullTerm" @after-select="selectedFullTerm" />
          <SpInput v-model="cargoOrders.term.content" style="margin-top: 15px" text-type="textarea" name="cargoOrders.term.content" type="gray"
                   :row="45" />
        </div>
      </div>
      <div class="flex-40" style="padding-left: 43px">
        <div class="">
          <div class="font18 fs-int pd-r-20" style="position: relative; z-index: 9">{{ $l('PackingList') }}</div>
          <SpUpload type="primary" :business-id="cargoOrders.id" :splitter1="$store.state.user.user.employerId" :upload-after-select="!!cargoOrders.id"
                    :default-files="packingList" class="position-input"
                    file-type="cargo/order-tct/packing-list" />
        </div>
        <div style="margin-top: 15px">
          <div class="gap">
            <span class="font18 fs-int">{{ $l('ProformaCP') }}</span>
            <SpSelect v-model="cargoOrders.term.proformaId" class="flex-1 position-input" name="cargoOrders.term.proformaId"
                      type="warn" :options="performTerms" width="423" @search="searchPerformTerm"
                      @after-select="selectedPerformTerm" />
            <!--            <SpButton type="primary2" width="155" height="53" class="mg-l-20">{{ $l('CPdocx') }}</SpButton> -->
          </div>
          <SpUploadGroup :default-files="performTermsContent" disabled class="mg-t-20" />
        </div>
        <div class="" style="margin-top: 15px">
          <div class="gap">
            <span class="font18 fs-int" style="position: relative; z-index: 99">{{ $l('FrequentlQuotedParagraphs') }}</span>
            <SpSelect v-model="cargoOrders.term.paragraphId" class="flex-60 position-input" name="`cargoOrders.term.paragraphId`"
                      type="warn" :options="requirementsTerms" width="423"
                      @search="(keyword) => searchRequirementsTerm(keyword, 1, 'requirements')"
                      @after-select="(seleted) => selectedToCoppy(seleted, requirementsTerms)" />
          </div>
        </div>
        <div style="margin-top: 15px">
          <div class="gap">
            <span class="font18 fs-int" style="position: relative; z-index: 99">{{ $l('CargoDescription') }}</span>
            <SpSelect v-model="cargoOrders.term.descriptionId" class="flex-60 position-input" name="`cargoOrders.term.descriptionId`"
                      type="warn" :options="descTerms" width="423"
                      @search="(keyword) => searchDescTerm(keyword, 1, 'description')"
                      @after-select="(seleted) => selectedToCoppy(seleted, descTerms)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { ref, reactive, computed, getCurrentInstance, onMounted, watch } from 'vue'
import SpCard from '@/components/common/SpCard.vue'
import SpSelect from '@/components/common/SpSelect.vue'
import SpInput from '@/components/common/SpInput.vue'
import SpUpload from '@/components/common/SpUpload.vue'
import SpTable from '@/components/common/SpTableDIY/SpTable.vue'
import SpTableColumn from '@/components/common/SpTableDIY/SpTableColumn.vue'
import { $l } from '@/mixins/i18nModule'
import SpButton from '@/components/common/SpButton.vue'
import SpUploadGroup from '@/components/common/SpUploadGroup.vue'
import { cargoTermChartingOwnedApi, cargoTermChartingSearchApi, getTermChartingApi } from '@/request/APIs/co'
import { getShipTypeApi } from '@/request/APIs/so'
import { getEnterpriseCorpDetailApi, getEnterpriseOptionsCorpApi } from '@/request/APIs/company'
import SpDatePicker from '@/components/common/SpDatePicker'
import _uniqBy from 'lodash/uniqBy'
import { fixNum } from '@/utils/convert'
import SpMessage from '@/components/common/SpMessage'
import { useRoute } from 'vue-router'

export default {
  name: 'CargoOrderEdit2',

  nameSpace: 'cargoOwner.cargoOrders.CargoOrderEdit',

  components: {
    SpDatePicker,
    SpCard,
    SpSelect,
    SpInput,
    SpUpload,
    SpTable,
    SpTableColumn,
    SpButton,
    SpUploadGroup
  },

  props: {
    modelValue: {
      type: Array,
      default: () => []
    },

    rowIndex: {
      type: Number,
      default: null
    },

    ftcontent: {
      tyep: String,
      default: ''
    }
  },

  emits: ['back'],
  setup (props, ctx) {
    const cargoOrders = computed({
      get () {
        return props.modelValue
      },
      set (nv) {
        ctx.emit('update:modelValue', nv)
      }
    })
    const back = () => {
      ctx.emit('back', 1, props.rowIndex)
    }

    // 承运船舶种类限制
    // const shipCategory = ref([])
    // getShipTypeApi().then(res => {
    //   if (res.code === 1) {
    //     shipCategory.value = Object.values(res.data).map(item => ({
    //       value: item.id,
    //       label: item.name
    //     }))
    //   }
    // })

    // 祖传条款
    const allTerms = ref([])
    const searchAllTerm = (keyWord, page = 1, type = 'all') => {
      getTermChartingApi({ class: type, keyWord, page }).then(res => {
        if (res.code === 1) {
          allTerms.value = res.data.data.map(item => ({
            label: item.subject,
            value: item.id,
            content: item.content
          }))
        }
      })
    }
    // 祖传条款
    const descTerms = ref([])
    const searchDescTerm = (keyWord, page = 1, type = 'all') => {
      getTermChartingApi({ class: type, keyWord, page }).then(res => {
        if (res.code === 1) {
          descTerms.value = res.data.data.map(item => ({
            label: item.subject,
            value: item.id,
            content: item.content
          }))
        }
      })
    }
    const requirementsTerms = ref([])
    const searchRequirementsTerm = (keyWord, page = 1, type = 'all') => {
      getTermChartingApi({ class: type, keyWord, page }).then(res => {
        if (res.code === 1) {
          requirementsTerms.value = res.data.data.map(item => ({
            label: item.subject,
            value: item.id,
            content: item.content
          }))
        }
      })
    }
    // 祖传条款
    const fullTerms = ref([])
    const searchFullTerm = (keyWord, page = 1) => {
      getTermChartingApi({ class: 'full', keyWord, page }).then(res => {
        if (res.code === 1) {
          fullTerms.value = res.data.data.map(item => ({
            label: item.subject,
            value: item.id,
            content: item.content
          }))
        }
      })
    }
    const fullTermsContent = ref('')
    const selectedFullTerm = (selected) => {
      const content = fullTerms.value.find(item => item.value === selected)?.content
      props.modelValue.term.content = content
      // fullTermsContent.value = content
    }
    const route = useRoute()
    onMounted(() => {
      if (route.query.orderId) {
        searchAllTerm('', 1, 'all')
        searchFullTerm('', 1)
        searchPerformTerm('', 1)
        searchDescTerm('', 1, 'description')
        searchRequirementsTerm('', 1, 'requirements')

        watch(() => props.ftcontent, (nv) => {
          if (nv) {
            props.modelValue.term.content = nv
            // fullTermsContent.value = nv
          }
        })
        watch(() => props.modelValue.term.proformaId, (nv) => {
          if (nv) {
            selectedPerformTerm(nv)
          }
        })
      }
    })

    const selectedToCoppy = (selected, options) => {
      const content = options.find(item => item.value === selected)?.content
      const oInput = document.createElement('input')
      oInput.value = content
      document.body.appendChild(oInput)
      oInput.select()
      document.execCommand('Copy')
      SpMessage.success('Copy succeeded! You can paste it to Full Terms / Brief Terms')
      oInput.remove()
    }

    const performTerms = ref([])
    const searchPerformTerm = (keyWord, page = 1) => {
      getTermChartingApi({ class: 'proforma', keyWord, page }).then(res => {
        if (res.code === 1) {
          performTerms.value = res.data.data.map(item => ({
            label: item.subject,
            value: item.id,
            content: item.content
          }))
        }
      })
    }
    const performTermsContent = ref('')
    const selectedPerformTerm = (selected) => {
      const content = performTerms.value.find(item => item.value === selected)?.content
      performTermsContent.value = Object.values(content || {}).map(url => ({
        url,
        type: 'img'
      }))
    }

    // 公司选项
    const acctCharterers = ref([])
    getEnterpriseOptionsCorpApi().then(res => {
      if (res.code === 1) {
        acctCharterers.value = res.data.filter(item => item.privSign > 0 && item.regLevel === 1 && [4, 6].includes(item.identity)).map(item => ({
          value: item.id,
          label: item.name
        }))
      }
    })
    const companyInfo = reactive({})
    const getCompanyInfo = (id) => {
      getEnterpriseCorpDetailApi(id).then(res => {
        if (res.code === 1) {
          companyInfo.country = res.data.country.name
          companyInfo.city = res.data.city.name
        }
      })
    }

    const packingList = computed(() => {
      const list = []
      if (cargoOrders.value.term?.packingListFiles?.files) {
        const files = cargoOrders.value.term?.packingListFiles?.files
        Object.keys(files).forEach(key => {
          list.push({
            type: 'img',
            url: files[key],
            id: key,
            name: files[key].split('/').pop()
          })
        })
      }
      return list
    })

    return {
      cargoOrders,
      back,
      fullTerms,
      searchFullTerm,
      selectedFullTerm,
      allTerms,
      searchAllTerm,

      descTerms,
      searchDescTerm,
      requirementsTerms,
      searchRequirementsTerm,
      fullTermsContent,
      // shipCategory
      performTerms,
      searchPerformTerm,
      selectedToCoppy,
      performTermsContent,
      selectedPerformTerm,
      acctCharterers,
      getCompanyInfo,
      companyInfo,
      packingList
    }
  }

}
</script>

<style scoped lang="less">
.gap {
  margin: @gap/2 0;
}

.CargoOrderEdit2 {
  .position-input{
    position: relative;
    top: -5px;
  }
  padding: @gap 36px;
  .flex-jc-bt();
  @item-title-flex: 30%;

  .card {
    text-align: left;

    .item {
      .gap();
      .flex();
      .flex-al-center();

      .title {
        flex: 0 0 @item-title-flex;
      }

      .input {
        flex: 1 1 70%;
      }

      .table {
        flex-shrink: 1;
        flex-basis: 20%;
      }
    }

    .item-jc-bt {
      .flex-jc-bt();
      .flex-al-center();
      .gap();

      .title {
        flex: 0 0 @item-title-flex;
      }
    }

    .buttons {
      margin-top: @gap*4;

      > * {
        margin: @gap*2 auto;
      }
    }
  }

  .right-side {
    text-align: left;
    margin-top: @gap*2;

    > * {
      padding: @gap;
    }
  }
}
</style>
